import React, { Component, Fragment } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';

import Footer from '../../../components/Footer';

import './style.scss';

export default class Directors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            data: require('./data.json'),
        };
    }
    handleSelect(key) {
        if (this.state.selected === key) {
            this.setState({
                selected: null,
            });
        } else {
            this.setState({
                selected: key,
            });
        }
    }
    render() {
        const { data } = this.state;
        return (
            <Fragment>
                <ReactFullpage
                    scrollBar
                    licenseKey={'509941D1-3F034827-933D440A-25570100'}
                    responsiveWidth={'881'}
                    render={comp => (
                        <ReactFullpage.Wrapper>
                            {data.items.map((item, key) => (
                                <div
                                    className="section directors"
                                    key={key}
                                    onClick={this.handleSelect.bind(this, key)}
                                >
                                    <div className="navgap"></div>
                                    <div
                                        className={
                                            item.right
                                                ? this.state.selected === key
                                                    ? 'item right selected'
                                                    : 'item right'
                                                : this.state.selected === key
                                                ? 'item selected'
                                                : 'item'
                                        }
                                    >
                                        {item.image ? (
                                            <img title={item.name} alt={item.name} src={item.image || ''} />
                                        ) : (
                                            <img alt="" />
                                        )}
                                        <div className={item.extend ? 'details extend' : 'details'}>
                                            <h1>{item.name}</h1>
                                            <h2 dangerouslySetInnerHTML={{ __html: item.position }}></h2>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            ></p>
                                        </div>
                                        {key === 6 ? null : (
                                            <div className="scroll">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                            <div className="section directors footer fp-auto-height">
                                <Footer />
                            </div>
                        </ReactFullpage.Wrapper>
                    )}
                />
            </Fragment>
        );
    }
}
